var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmergeCells(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20H14V16H10V20ZM16 20H20V16H16V20ZM10 14H14V10H10V14ZM16 14H20V10H16V14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8H8V4H4V8ZM16 8H20V4H16V8ZM10 8H14V4H10V8ZM4 14H8V10H4V14ZM4 20H8V16H4V20Z",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmergeCells);
export default __webpack_public_path__ + "static/media/unmerge_cells.6a5b42200f54eb0faeb8de693dea881a.svg";
export { ForwardRef as ReactComponent };